const MONTHS_UPPER = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

/**
 * Returns fiscal-order month labels in uppercase.
 * For Retail 5-4-4 calendars, labels are prefixed with fiscal period numbers (P1..P12).
 */
export const generateMonthLabels = (startMonth: number, fiscalCalendarRuleSet?: number): string[] => {
    const rotationIndex = (startMonth - 1 + 12) % 12;
    const orderedMonths = MONTHS_UPPER
        .slice(rotationIndex)
        .concat(MONTHS_UPPER.slice(0, rotationIndex));

    if (fiscalCalendarRuleSet !== 1) {
        return orderedMonths;
    }

    return orderedMonths.map((month, index) => `P${index + 1} - ${month}`);
};

